import { useMemo, useState } from 'react';
import type { DataKPI } from '../../../redux/config/chart-data';

import type { WidgetConfigurationData } from '../../../redux/config/widgetApi';
import { getCustomKpiDomainValue, getCustomYScaleDomainValue } from '../generalFunctions/get-domaincharts';

export function useKPIDomainValue(configurationData?: WidgetConfigurationData, transformedData?: DataKPI[]) {
  const [kpiDomain, setKPIDomain] = useState<[number, number] | undefined>();

  useMemo(() => {
    if (transformedData && configurationData) {
      const { max: maxValue, min: minValue } = getCustomKpiDomainValue(transformedData, configurationData);
      const widgetConfig = configurationData.widgetConfig;
      if (widgetConfig) {
        setKPIDomain(
          getCustomYScaleDomainValue({
            minChartValue: minValue,
            maxChartValue: maxValue,
            maxScaleValue: widgetConfig.yScaleMax,
            minScaleValue: widgetConfig.yScaleMin,
          })
        );
      } else {
        setKPIDomain([minValue, maxValue ? maxValue : 2]);
      }
    }
  }, [transformedData, configurationData]);

  return kpiDomain;
}
